const getModalByName = (state, name) => state.modalStore.modals.get(name);

const checkModalVisibility = (state, name) => !!state.modalStore.modals.get(name);

export { getModalByName, checkModalVisibility };
